module.exports = __webpack_public_path__ + "img/icon4.86e7bb9d.png";